import styled from 'styled-components';
import { Spinner } from 'ui/spinner';

const LoaderContainer = styled.div`
  position: absolute;
  inset: 0;
`;

export const testIds = {
  pageLoader: 'segmentation-page-loader',
};

export const SegmentationPageLoader = () => {
  return (
    <LoaderContainer>
      <Spinner data-test={testIds.pageLoader} />
    </LoaderContainer>
  );
};
